import {
  SET_APPLICATION_STEP,
} from './mutation-types';
import {
  APPLICATION_STEP,
} from '~/constants/applicationStep';
import OperatorApplicationAPI from '~/services/api/OperatorApplicationAPI';
import OrganizationAPI from '~/services/api/OrganizationsAPI';

/**
 * Set application step
 * @param {object} state - the vuex state object
 * @param {string} applicationStep - Global application state linked to onboarding steps
 */
export async function setApplicationStep({
  commit,
}, applicationStep) {
  commit(SET_APPLICATION_STEP, applicationStep);
}

/**
 * Rules of display for the homepage depending of the actions/status of the user
 * TODO: Remove this logic (not clear enough). 2 options :
 * - put in in the backend side
 * - put it in a separated chunk of code like a helper
 * @param dispatch
 * @param userId
 * @param organizationId
 * @param flag
 * @returns {Promise<void>}
 */
export async function fetchOperatorApplication({
  dispatch,
}, { userId, organizationId, flag }) {
  let organization;
  if (organizationId) {
    organization = await OrganizationAPI.getOrganization(organizationId);
  }
  const operatorApplication = await OperatorApplicationAPI.fetchOperatorApplication(userId);
  const application = operatorApplication?.data?.attributes || null;
  // autovalidation rules
  if (flag) {
    if (!application) {
      dispatch('setApplicationStep', APPLICATION_STEP.NEW);
    } else if (application?.validated === false) {
      dispatch('setApplicationStep', APPLICATION_STEP.REFUSED);
    } else if (!!organizationId && !organization?.data?.attributes?.billing_info) {
      dispatch('setApplicationStep', APPLICATION_STEP.DOCUMENT);
    } else if ((organization?.data?.attributes?.ready || organization?.data?.ready)
      && application?.validated === true) {
      dispatch('setApplicationStep', APPLICATION_STEP.VALIDATED);
    }
    // old manuals rules
    /**
     * TODO: Remove this part after acceptation of featIcAutoValidation
     */
  } else if (!application) dispatch('setApplicationStep', APPLICATION_STEP.NEW);
    else if (application.validated === null) dispatch('setApplicationStep', APPLICATION_STEP.WAITING_ACCEPTATION);
    else if (application.validated === false) dispatch('setApplicationStep', APPLICATION_STEP.REFUSED);
    else if ((organization?.data?.attributes?.ready || organization?.ready) && application.validated === true) dispatch('setApplicationStep', APPLICATION_STEP.VALIDATED);
    else if (application.validated === true && (!organization?.data?.attributes?.ready || !organization?.ready)) dispatch('setApplicationStep', APPLICATION_STEP.DOCUMENT);
}
